const CHUNK_SIZE = 10 * 1024 * 1024 * 5;
async function uploadChunk(uploadUrl, chunk, startByte, endByte, totalSize) {
  const contentRange = `bytes ${startByte}-${endByte - 1}/${totalSize}`;
  const formData = new FormData();
  formData.append('upload_url', uploadUrl);
  formData.append('chunk', chunk);
  const res = await fetch('/api/folder_files/upload_chunk', {
    method: 'POST',
    headers: {
      'X-Content-Range': contentRange,
      'X-Chunk-Size': chunk.size.toString()
    },
    body: formData
  });
  if (!res.ok) {
    const error = await res.json();
    throw new Error(`Chunk upload failed: ${error.error || res.status}`);
  }
  const result = await res.json();
  const gcsStatusCode = parseInt(result.status, 10);
  if (gcsStatusCode === 308) {
    return false;
  }
  if (gcsStatusCode === 200 || gcsStatusCode === 201) {
    return true;
  }
  throw new Error(`Unexpected GCS status: ${result.status}`);
}
export const getResumableUploadUrl = async (filename, contentType, getPresignedUrl) => {
  const {
    upload_url,
    key
  } = await getPresignedUrl(filename, contentType);
  if (!upload_url || !key) throw new Error('Invalid resumable upload URL');
  return {
    uploadUrl: upload_url,
    key
  };
};
export const uploadFileToGCP = async (uppy, file, uploadUrl) => {
  const totalSize = file.size;
  let startByte = 0;
  while (startByte < totalSize) {
    const endByte = Math.min(startByte + CHUNK_SIZE, totalSize);
    const chunk = file.data.slice(startByte, endByte);
    const done = await uploadChunk(uploadUrl, chunk, startByte, endByte, totalSize);
    const progress = Math.min(100, Math.round(endByte / totalSize * 100));
    uppy.emit('manual-progress-update', file, progress);
    if (done) {
      break;
    }
    startByte = endByte;
  }
  return true;
};
export const uploadFile = async (uppy, file, getPresignedUrl, createFolderFileWithCloudFileRecord) => {
  try {
    uppy.emit('manual-progress-update', file, 0);
    const {
      uploadUrl,
      key
    } = await getResumableUploadUrl(file.name, file.type, getPresignedUrl);
    file.meta.key = key;
    uppy.emit('manual-progress-update', file, 5);
    await uploadFileToGCP(uppy, file, uploadUrl);
    uppy.emit('manual-progress-update', file, 95);
    const cloudFileRecord = {
      name: file.name,
      key,
      content_type: file.type,
      size: file.size
    };
    await createFolderFileWithCloudFileRecord(cloudFileRecord, file);
    uppy.emit('manual-progress-update', file, 100);
    uppy.emit('upload-success', file, {
      status: 200,
      body: cloudFileRecord,
      cloudFileRecord,
      uploadURL: uploadUrl
    });
  } catch (error) {
    console.error('Upload failed:', error);
    uppy.emit('upload-error', file, error);
  }
};
export const uploadAllSelectedFiles = async (uppy, getPresignedUrl, createFolderFileWithCloudFileRecord) => {
  const files = uppy.getFiles();
  if (files.length === 0) {
    console.error('No files to upload');
    return false;
  }
  for (const file of files) {
    await uploadFile(uppy, file, getPresignedUrl, createFolderFileWithCloudFileRecord);
  }
  const allFiles = uppy.getFiles();
  const successfulFiles = allFiles.filter(f => f.progress?.uploadComplete);
  const failedFiles = allFiles.filter(f => !f.progress?.uploadComplete);
  uppy.emit('complete', {
    successful: successfulFiles,
    failed: failedFiles
  });
};